export default "__VITE_ASSET__DZESckbE__"